// extracted by mini-css-extract-plugin
export default {"Box":"Controls-module__Box--sPhko","IconButton":"Controls-module__IconButton--ZeMXB"};